import React from 'react';

const ErscheinungsbildHeader = () => {
  return (
    <div className="bg-white px-6 py-6 sm:py-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
          Erscheinungsbild
        </h2>
        <p className="mt-2 text-lg leading-8 text-gray-600">
          Hier kannst du das Design deiner sVisit-Profilseite anpassen.
        </p>
      </div>
    </div>
  );
};

export default ErscheinungsbildHeader;
